import { Typography, UniversalImage, LinkButton } from '@monoimin/atoms';
import { getAssetImageDimensions } from 'libs/utils/src/lib/images/getAssesImageDimensions';

import type { C2APopupStoryblok } from '@monoimin/sb-types';

type PopupContentProps = {
  content: C2APopupStoryblok;
  onClick: () => void;
};

export const PopupContent = ({ content, onClick }: PopupContentProps) => {
  const { title = '', link, image, buttonText } = content;

  const dimensions = getAssetImageDimensions(image);

  return (
    <div className='px-4 max-w-5xl mx-auto py-5 md:py-6 flex flex-row relative justify-between'>
      {image && (
        <div className='hidden w-48 lg:block relative -top-20'>
          <UniversalImage
            pattern='dimensions'
            width={dimensions.width}
            height={dimensions.height}
            src={image.filename}
            className='object-contain absolute w-48 h-64 group-hover:-translate-y-5 duration-200 ease-in'
            alt={image.alt || 'popup image'}
            sizes='198px'
          />
        </div>
      )}
      <div className='flex flex-col lg:flex-row max-w-3xl items-start lg:items-center gap-4 lg:gap-12 lg:pr-6 xl:pr-0'>
        {title && (
          <Typography className='text-h3 lg:text-h3-xl font-bold'>
            {title}
          </Typography>
        )}
        <div onClick={onClick}>
          <LinkButton
            className='lg:w-max'
            size='table'
            theme='blue'
            href={link?.url || '/'}
          >
            {buttonText}
          </LinkButton>
        </div>
      </div>
    </div>
  );
};
